import { render, staticRenderFns } from "./RecoBrowse.vue?vue&type=template&id=37f716a0&"
import script from "./RecoBrowse.vue?vue&type=script&lang=js&"
export * from "./RecoBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports